/* eslint-disable */
export const region8Barangays = [
    {
        CITY: 'ABUYOG',
        BARANGAY: 'ALANGILAN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BALINSASAYAO',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BALOCAWE',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BALOCAWEHAY',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BARAYONG',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BITO (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BUAYA',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BULAK',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BUNTAY (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'BURUBUD-AN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'CADAC-AN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'CAGBOLO',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'CAN-APORONG',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'CANMARATING',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'CAN-UGUIB (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'CAPILIAN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'COMBIS',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'DINGLE',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'GUINTAGBUCAN (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'HAMPIPILA',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'KIKILO',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'LARAY',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'LAWA-AN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'LOYONSAWANG (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'MAG-ATUBANG',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'MAHAGNA (NEW CAGBOLO)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'MAITUM',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'MALAGUICAY',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'MATAGNAO',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'NALIBUNAN (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'NEBGA',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'NEW TALIGUE',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'ODIONGAN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'OLD TALIGUE',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'PAGSANG-AN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'PAGUITE',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'PARASANON',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'PICAS SUR',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'PINAMANAGAN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'SANTA FE (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'SANTO NIÑO (POB.)',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'TABIGUE',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'TADOC',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'TIB-O',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'TINALIAN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'TINOCOLAN',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'TUY-A',
    },
    {
        CITY: 'ABUYOG',
        BARANGAY: 'VICTORY (POB.)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'ASLUM',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'ASTORGA (BURABOD)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'BINONGTO-AN',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'BINOTONG',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'BLUMENTRITT (POB.)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'BOBONON',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'BORSETH',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'BURI',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'CABADSAN',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'CALAASAN',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'CAMBAHANON',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'CAMBOLAO',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'CANVERTUDES',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'CAPIZ',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'CAVITE',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'EKIRAN',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'HINAPOLAN',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'HOLY CHILD I (POB.)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'HOLY CHILD II (POB.)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'HUBANG',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'HUPIT',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'LANGIT',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'LINGAYON',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'LUKAY',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'MILAGROSA (POB.)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'MUDBORON',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'P. BARRANTES',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'PENALOSA',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'PEPITA',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SALVACION POBLACION',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SAN ANTONIO POB. (PATONG NORTE)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SAN FRANCISCO EAST',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SAN FRANCISCO WEST',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SANTO NIÑO (POB.)',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'TABANGOHAY',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'TOMBO',
    },
    {
        CITY: 'ALANGALANG',
        BARANGAY: 'VETERANOS',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'BENOLHO',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'CAMBALADING',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'DAMULA-AN',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'DONA MARIA (KANGKUIRINA)',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'SEGUINON',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'SHERWOOD',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'TABGAS',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'TALISAYAN',
    },
    {
        CITY: 'ALBUERA',
        BARANGAY: 'TINAG-AN',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'GOV. E. JARO (BAGAHUPI)',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'GUINTIGUI-AN',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'LUKAY',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'MAGCASUANG',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'MALIBAGO',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'NAGA-ASAN',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'PAGSULHUGON',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'PLANZA',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'POBLACION DISTRICT I',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'POBLACION DISTRICT II',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'POBLACION DISTRICT III',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'POBLACION DISTRICT IV',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'RIZAL I',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'RIZAL II',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'SAN RICARDO',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'SANGPUTAN',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'TAGUITE',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'UBAN',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'BABATNGON',
        BARANGAY: 'VILLA MAGSAYSAY',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'ABANGO',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'AMAHIT',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'BALIRE',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'BUKID',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'CABARASAN',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'CABOLO-AN',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'CALINGCAGUING',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'CAN-ISAK',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'CANOMANTAG',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'CUTA',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'DOMOGDOG',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'DUKA',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'GUINDAOHAN',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'HIAGSAM',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'HILABA',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'HINUGAYAN',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'IBAG',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'MINUHANG',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'MINUSWANG',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'PIKAS',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'POBLACION DIST. I',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'POBLACION DIST. II',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'POBLACION DIST. III',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'POBLACION DIST. IV',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'POBLACION DIST. V',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'POBLACION DIST. VI (NEW ROAD)',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'PONGSO',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'ROOSEVELT',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'SANTARIN',
    },
    {
        CITY: 'BARUGO',
        BARANGAY: 'TUTUG-AN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'ALTAVISTA',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'AMBACAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'AMGUHAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'AMPIHANON',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'BALAO',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'BANAHAO',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'BIDLINAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'BITANHUAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'BUBON',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'BUTIGAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'CANDADAM',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'CIABO',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'GA-AS',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'GABAS',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'GAKAT',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'GUADALUPE (UTOD)',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'GUBANG',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'HIBUNAWAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'HIGULOAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'HILAPNITAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'HIPUSNGO',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'IGANG',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'JAENA',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'KABALASAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'KABATUAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'KABUNGAAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'KAGUMAY',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'KAMBONGGAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'KAN-IPA',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'KANSUNGKA',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'KANTAGNOS',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'KILIM',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'LINTAON',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MAGANHAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MAILHI',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MAITUM',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MAKINHAS',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MAPGAP',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MARCOS',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MASLUG',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MATAM-IS',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MAYBOG',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MAYPATAG',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MONTE VERDE',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'MONTERICO',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'PALHI',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'PANGASUNGAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'PANSAGAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 1',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 10',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 11',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 12',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 13',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 14',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 15',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 16',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 17',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 18',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 19',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 2',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 20',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 21',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 22',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 23',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 3',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 4',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 5',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 6',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 7',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 8',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POBLACION ZONE 9',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'POMPONAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'SAPA',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'VILLA MAG-ASO',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'VILLA SOLIDARIDAD',
    },
    {
        CITY: 'BAYBAY',
        BARANGAY: 'ZACARITO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'ABUYOGON',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'ARADO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'BALAO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'BALATSON',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'BALORINAY',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'BOBON',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'BURI',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'CAANISLAGAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'CADAHUNAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'CAGANGON',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'CALI',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'CALSADAHAY',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'CANDAG-ON',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'CANSIBOY',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'CATAGBACAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'DAMULO-AN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'DINA-AYAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'DUMALAG (PUSOD)',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'GAMAY',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'GITABLAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'HAPUNAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'HIBONAWAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'HUGPA EAST',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'HUGPA WEST',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'KAGBANA',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'KALAO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'KALIPAYAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'KAPARASANAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'LAGUIWAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'LIMBURAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'LOGSONGAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'MAABAB',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'MAGHUBAS',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'MAHAGNAO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'MALABCA',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'MALAGUINABOT',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'MALAIHAO (SAN RAMON)',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'MATIN-AO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'MOGUING',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'PAGHUDLAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'PAITAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'PANGDAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'POBLACION DISTRICT I',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'POBLACION DISTRICT II',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'POBLACION DISTRICT III',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'POBLACION DISTRICT IV',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'POBLACION DISTRICT IX',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'POBLACION DISTRICT V',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'POBLACION DISTRICT VI',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'POBLACION DISTRICT VII',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'POBLACION DISTRICT VIII',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'SAMBEL',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'SAN ESTEBAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'SAN JOSE EAST',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'SAN JOSE WEST',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'TABUANON',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'TAGADTARAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'TAGHUYAN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'TAKIN',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'TAMBIS (NABOYA)',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'TAMBUKO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'TOLOYAO',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'VILLA CORAZON',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'VILLA PATRIA',
    },
    {
        CITY: 'BURAUEN',
        BARANGAY: 'VILLA ROSAS (CABANG)',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'ABANILLA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'AGAS',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'ANISLAGAN',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'BUNACAN',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'CABALHIN',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'CABALQUINTO',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'CABRADILLA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'CANEJA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'CANTONGHAO',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'CAROYOCAN',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'CASIONGAN',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'CRISTINA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'DALUMPINES',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'DON LUIS',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'DULAO',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'EFE',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'ENAGE',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'ESPINOSA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'FERDINAND E. MARCOS',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'GARGANERA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'GARRIDO',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'GUADALUPE (GUADALUPE MENDOZA)',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'GUTOSAN',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'IGANG',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'INALAD',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'JUBAY',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'JUSON',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'KAWAYAN BOGTONG',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'KAWAYANAN',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'KOKOY ROMUALDEZ',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'LABTIC',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'LARAY',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'M. VELOSO',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'MAHAIT',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'MATAGOK',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'NIPA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'OBISPO',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'PADOGA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'PAGATPAT',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'PATES',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'PAULA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'PETROLIO',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'RAILES',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'TABLA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'TAGHARIGUE',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'VILLALON',
    },
    {
        CITY: 'CALUBIAN',
        BARANGAY: 'VILLANUEVA',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'BALUCANAD',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'CABUL-AN',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'CULASIAN',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'GAYAD',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'GUINADIONGAN',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'LEMON',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'MANLOY',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'NAUGUISAN',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'PINAMOPOAN',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'POBLACION ZONE I',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'POBLACION ZONE II',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'POTOT',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'TALAIRAN',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'TOLIBAO',
    },
    {
        CITY: 'CAPOOCAN',
        BARANGAY: 'VISARES',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'BAGONG LIPUNAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'BALILIT',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'BARAYONG',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'BARUGOHAY CENTRAL',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'BARUGOHAY NORTE',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'BARUGOHAY SUR',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'BAYBAY (POB.)',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'BINIBIHAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'BISLIG',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'CAGHALO',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'CAMANSI',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'CANAL',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'CANDIGAHUB',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'CANFABI',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'CANLAMPAY',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'CUTAY',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'EAST VISORIA',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'GUINDAPUNAN EAST',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'GUINDAPUNAN WEST',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'HILUCTOGAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'JUGABAN (POB.)',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'LIBO',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'LOWER HIRAAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'LOWER SOGOD',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'MACALPI',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'MANLOY',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'NAUGUISAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'PAGLAUM',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'PANGNA',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'PARAG-UM',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'PARINA',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'PILORO',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'PONONG (POB.)',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'RIZAL (TAGAK EAST)',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'SAGKAHAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'SAN MATEO (POB.)',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'SAWANG (POB.)',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'TAGAK',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'TANGNAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'TINAGUBAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'UPPER HIRAAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'UPPER SOGOD',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'UYAWAN',
    },
    {
        CITY: 'CARIGARA',
        BARANGAY: 'WEST VISORIA',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'ABACA',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'ABRE',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'BALILIT',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'BANAYON',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'BOLIRAO',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'BUNTAY',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CAANISLAGAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CABARIWAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CABULORAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CALIPAYAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CALSADAHAY',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CALUCTOGAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CALUTAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CAMONO-AN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CANDAGARA',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CANLINGGA',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CANSAMADA EAST',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CANSAMADA WEST',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'CAPULHAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'DIGAHONGAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'GUINARONA',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'HIABANGAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'HILABAGO',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'HINABUYAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'HINOLOGAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'HITUMNOG',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'LAPU-LAPU POB. (DIST. 2)',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'LOBE-LOBE',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'LOBE-LOBE EAST',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'LOS MARTIRES',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'LUSAD POB. (DIST. 6)',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'MACAALANG',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'MALIWALIW',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'MARAGONDONG',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'ORMOCAY',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'PALACIO',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'PANDA',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'PATOC',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'POPONTON',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SAMPAO EAST POB. (DIST. 9)',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SAMPAO WEST POB. (DIST. 8)',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SAN ANTONIO POB. (DIST. 5)',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SAN BENITO',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SAN JOSE POB. (DIST. 1)',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SAN ROQUE POB. (DIST. 3)',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SAWAHON',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'SIRAB',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'STA. MESA POB. (DIST. 7)',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'TAGKIP',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'TALINHUGON',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'TIN-AO',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'TUNGA POB. (DIST. 4)',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'TUYA',
    },
    {
        CITY: 'DAGAMI',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'ALEGRE',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'ARADO',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'BARBO (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'BATUG',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'BOLONGTOHAN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'BUNTAY (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CABACUNGAN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CABARASAN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CABATO-AN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CALIPAYAN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CALUBIAN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CAMBULA DISTRICT (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CAMITOC',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CAMOTE',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CANDAO (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'CATMONAN (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'COMBIS (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'DACAY',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'DEL CARMEN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'GENERAL ROXAS',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'HIGHWAY (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'LUAN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'MARICUM',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'MARKET SITE (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'ROMUALDEZ',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SABANG DAGUITAN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SAN MIGUEL (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SERRANO (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'SUNGI (POB.)',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'TABU',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'DULAG',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'AGUTAYAN',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'ATABAY',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'BAAS',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'BAGONG LIPUNAN',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'BALIW',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'BANTIGUE',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'BON-OT',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'BUNG-AW',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'CACAO',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'CAMPINA',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'CATANDOG 1',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'CATANDOG 2',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'CENTRAL BARANGAY (POB.)',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'EASTERN BARANGAY (POB.)',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'HAMPANGAN',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'HIMO-AW',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'HITUDPAN',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'IMELDA MARCOS (PONG-ON)',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'KANGHA-AS',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'KANG-IRAS',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'LAMAK',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'LUNANG',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'MAGNANGOY',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'MANAUL',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'MARANGOG',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'MATAPAY',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'NAVAL',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'OWAK',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'PA-A',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'PONTOD',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'PROTECCION',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'SANTA MARGARITA',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'TABUNOK',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'TAGNATE',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'TAMBIS',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'TEJERO',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'TUGUIPA',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'UTANAN',
    },
    {
        CITY: 'HILONGOS',
        BARANGAY: 'WESTERN BARANGAY (POB.)',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'ANAHAW',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'ANOLON',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'BALDOZA',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'BONTOC',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'BULACAN',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'CANHA-AYON',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'CAPUDLOSAN',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'DOOS DEL NORTE',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'DOOS DEL SUR',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'HIMACUGO',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'HIMOKILAN ISLAND',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'MABAGON',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'MAHILUM',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'TABOK',
    },
    {
        CITY: 'HINDANG',
        BARANGAY: 'TAGBIBI',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'APID',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'CABULISAN',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'CAMINTO',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'CAN-ANGAY',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'CAULISIHAN',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'CONALUM',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'DE LOS SANTOS (MAHILUM)',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'GUINSANGA-AN',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'HINABAY',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'JUBASAN',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'MACAGOCO',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'MALJO',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'MARAO',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'TAHUD',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'TAOTAON',
    },
    {
        CITY: 'INOPACAN',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'ANISLAG',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'APALE',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'BANTIGUE',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'BENOG',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'BILWANG',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'CAN-ANDAN',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'CANGAG',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'HONAN',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'MARVEL (POB.)',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'MATLANG',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'MONTE ALEGRE',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'PUTING BATO',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'SANTO NIÑO (POB.)',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'TABUNOK',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'TOLINGON',
    },
    {
        CITY: 'ISABEL',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'ALAHAG',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'ATIPOLO',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'BATUG',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'BIAS ZABALA',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'BUKID',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'BURI',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'CANAPUAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'CANHANDUGAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'CROSSING RUBAS',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'DARO',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'DISTRICT IV (POB.)',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'HIAGSAM',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'HIBUCAWAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'HIBUNAWON',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'KAGLAWAAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'KALINAWAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'LIKOD',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'MACANIP',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'MACOPA',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'MAG-ASO',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'OLOTAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'PALANOG',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'PANGE',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'PARASAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'SAGKAHAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'SARI-SARI',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'TINAMBACAN',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'TUBA',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'UGUIAO',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'VILLA PAZ',
    },
    {
        CITY: 'JARO',
        BARANGAY: 'VILLAGONZOILO (VILLA CONSUELO)',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'ABUYOGAY',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'ANDRES BONIFACIO',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'BATUG',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'BINULHO',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'CALZADA',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'CANCAYANG',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'CARANHUG',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'CARAYE',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'CASALUNGAN',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'COMATIN',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'GUINDAPUNAN',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'INAYUPAN',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'LARAY',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'MAGSAYSAY (RESPONDE)',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'MALITBOGAY',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'MANARUG',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'MANLILISID',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'NALIWATAN',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'ODIONG',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'PICAS NORTE',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'PINOCAWAN',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'POBLACION ZONE 1',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'POBLACION ZONE 2',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'SAN SOTERO (TAMBIS)',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'TALISAYAN',
    },
    {
        CITY: 'JAVIER',
        BARANGAY: 'ULHAY',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'ANIBONG',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'ASLUM',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'BALANTE',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'BONGDO',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'CALBASAG',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'CUYA-E',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'DITA',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'GITABLA',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'HINDANG',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'INAWANGAN',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'JURAO',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'POBLACION DISTRICT I',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'POBLACION DISTRICT II',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'POBLACION DISTRICT III',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'POBLACION DISTRICT IV',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'TAGKIP',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'TOLOSAHAY',
    },
    {
        CITY: 'JULITA',
        BARANGAY: 'VILLA HERMOSA',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'AGUITING',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'CACAO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'HILUCTOGAN',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'KAWAYAN',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'LIBONGAO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'LIM-AO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'LONOY',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'MAHAWAN',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'MASARAYAO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'MONTE ALEGRE',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'MONTE BELLO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'NAGHALIN',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'NATUBGAN',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'TONGONAN',
    },
    {
        CITY: 'KANANGA',
        BARANGAY: 'TUGBONG',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'BACHAO',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'BACO',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'BAGABA-O',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'BASUD',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'BELEN',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'CALAGUISE',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'CONSUEGRA',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'CULASI',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'DANUS',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'ELIZABETH',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'KAWAYAN',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'MAANDA',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'MACUPA',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'MATALOTO',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'PALARAO',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'PALID I (ILAWOD)',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'PALID II (IRAYA)',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'PARASAN',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'SALOG',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'SAMBULAWAN',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'TAG-ABACA',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'TAPOL',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'TIGBAWAN',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'TINOCDUGAN',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'TOCTOC',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'UGBON',
    },
    {
        CITY: 'LEYTE',
        BARANGAY: 'WAGUE',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'ALEJOS',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'AMAGOS',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'ANAHAWAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BAGO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BAGONG BAYAN DISTRICT (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'BULI',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'CEBUANA',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'DAAN LUNGSOD',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'DAWAHON',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'DOLHO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'DOMAGOCDOC',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'GUERRERO DISTRICT (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'HIMAMAA',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'INIGUIHAN DISTRICT (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'KALANGGAMAN DISTRICT (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'LIBERTY (BINALIW)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'MARCELO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'NAGA',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'PONONG',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'RIVILLA',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'TABUNOK',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'TINAGO DISTRICT (POB.)',
    },
    {
        CITY: 'BATO',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BAGACAY EAST',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BAGACAY WEST',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BOCAWON',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BONGTOD',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BURACAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CAABANGAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CACAO',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CAGNGARAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CALABNIAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CALAGHUSAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CALTAYAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'CANBANEZ',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'DUYOG',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'GIMENARAT EAST',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'GIMENARAT WEST',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LIMBA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LUBI-LUBI',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LUNETA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'MAG-ASO',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'MOROBORO',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'PANSUD',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'PILIWAY',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'POBLACION DISTRICT 1',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'POBLACION DISTRICT 2',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'POBLACION DISTRICT 3',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'POBLACION DISTRICT 4',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'QUIONG',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SAN VICTORAY',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'TABANG',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'TARUGAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BANAT-E',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BASUD',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BAWOD (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BUNACAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CABUNGAAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CAPINAHAN (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CROSSING (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'DAJA-DAKU',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'DAJA-DIOT',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'HACIENDA MARIA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MATUNGAO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'PARIL',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'TAGLAWIGAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BAIRAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CABATIANUHAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CANAP',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CAPILIHAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CARAYCARAY',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CAYARE (WEST POBLACION)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'GUINCIAMAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'IMPO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'KINALUMSAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LIBTONG (EAST POBLACION)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LUKAY',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MALAGUINABOT',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MALPAG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MAWODPAWOD',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PINARIGUSAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BACULANAD',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BADIANGAY',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'CATOOGAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'CUTAY',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'GAPAS',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'MILAGROSA',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'PILIT',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'SAN MIGUELAY',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'TIBAK',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'ZONE 1 (POB.)',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'ZONE 2 (POB.)',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'ZONE 3 (POB.)',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'ZONE 4 POB. (CABANGCALAN)',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'BATUG',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'CAPUDLOSAN',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'CASUNTINGAN',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'CAUSWAGAN',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'DONA JOSEFA',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'KILING',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'LANAWAN',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'LIWAYWAY',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'MAYA',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'OGUISAN',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'PALALE 1',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'PALALE 2',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'POBLACION DISTRICT 1',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'POBLACION DISTRICT 2',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'POBLACION DISTRICT 3',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'PONGON',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'ROMUALDEZ',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'TINAWAN',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'TUYO',
    },
    {
        CITY: 'MACARTHUR',
        BARANGAY: 'VILLA IMELDA',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'CAMPIN',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'CUATRO DE AGOSTO',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'HILUCTOGAN',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'HILUSIG',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'HIMAMARA',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'HINAGUIMITAN',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'LIBERACION',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'MABUNGA',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'MAGSUGANAO',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'MALIPOON',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'PALANOGAN',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'PARIL',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'PINAMONOAN',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'POLAHONGON',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'UGUIS',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'MAHAPLAG',
        BARANGAY: 'UPPER MAHAPLAG',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'BALAGTAS',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'BONOY (POB.)',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'BULAK',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'CAMBADBAD',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'CANDELARIA',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'CANSOSO',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'MALAZARTE',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'MANSAHAON',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'MANSALIP (POB.)',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'MASABA',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'NAULAYAN',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'RIVERSIDE (POB.)',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'SAN DIONISIO',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'SAN GUILLERMO',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'SAN MARCELINO',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'MATAG-OB',
        BARANGAY: 'TALISAY (POB.)',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'AGBANGA',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'ALTAVISTA',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'BAGONG LIPUNAN',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'CAHAGNAAN',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'CANINGAG',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'CARIDAD NORTE',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'CARIDAD SUR',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'ELEVADO',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'HITOOG',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'ITUM',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'LOWAN',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'MONTE ALEGRE',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'PRESIDENT GARCIA',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'SANTA PAZ',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'SANTO NIÑO (POB.)',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'TAGLIBAS IMELDA',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'TAG-OS',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'TEMPLANZA',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'WATERLOO',
    },
    {
        CITY: 'MATALOM',
        BARANGAY: 'ZARAGOZA',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'A. BONIFACIO',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'CALIPAYAN',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'CAMANSI',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'GENERAL ANTONIO LUNA',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'ORMOCAY',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'POBLACION ZONE 1',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'POBLACION ZONE 2',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'POBLACION ZONE 3',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'MAYORGA',
        BARANGAY: 'WILSON',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'BINABAYE',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'CABALIWAN',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'CALUNANGAN',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'CALUNASAN',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'CAMBALONG',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'CANBANTUG',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'CAN-UNZO',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'CASILDA',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'LAMANOC',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'LUNDAG',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'MACARIO',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'MAHALIT',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'MASUMBANG',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'MAT-E',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'PUERTO BELLO',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MERIDA',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'AIRPORT',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'ALTA VISTA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BAGONG',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BAGONG BUHAY',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BANTIGUE',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 13 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 14 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 15 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 16 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 17 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 18 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 19 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 20 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 21 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 22 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 23 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 24 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 25 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 26 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 27 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 28 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 29 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BAYOG',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BILIBOY',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'BOROK',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CABAON-AN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CABINTAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CABULIHAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CAGBUHANGIN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CAMP DOWNES',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CAN-ADIENG',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CAN-UNTOG',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'COGON COMBADO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'CURVA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'DANHUG',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'DAYHAGAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'DOMONAR',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'DON FELIPE LARRAZABAL',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'DON POTENCIANO LARRAZABAL',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'DONA FELIZA Z. MEJIA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'DONGHOL',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'GAAS',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'GREEN VALLEY',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'GUINTIGUI-AN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'HIBUNAWON',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'HUGPA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'JUATON',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'KADAOHAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'LABRADOR (BALION)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'LAO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'LEONDONI',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'LICUMA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'LILOAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MABATO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MACABUG',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MAGASWI',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MANLILINAO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MARGEN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MAS-IN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MATICA-A',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MILAGRO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'MONTERICO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'NASUNOGAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'NAUNGAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'NUEVA SOCIEDAD',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'NUEVA VISTA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'QUEZON JR.',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'RUFINA M. TAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SABANG BAO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SAN PABLO (SIMANGAN)',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'SUMANGGA',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'TAMBULILID',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'TONGONAN',
    },
    {
        CITY: 'ORMOC',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'ANAHAWAY',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'ARADO',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'BARAYONG',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'BURI (POB.)',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CABARASAN DAKU',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CABARASAN GUTI',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CAMPETIK',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CANDAHUG',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CANGUMBANG',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CANHIDOC',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CAPIRAWAN',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CASTILLA',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CAVITE EAST (POB.)',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'CAVITE WEST (POB.)',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'COGON (COGON SAN JOAQUIN)',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'GACAO',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'GUINDAPUNAN',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'LUNTAD (POB.)',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'NAGA-NAGA',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'PAWING',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'SAN MIGUEL (POB.)',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'TACURANGA',
    },
    {
        CITY: 'PALO',
        BARANGAY: 'TERAZA',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'BAGUINBIN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'BELEN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'BITAOG POB. (YPIL III)',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CADUHAAN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CAMBAKBAK',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CAMBINOY',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CANGCOSME',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CANGMUYA',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CANIPAAN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CANTANDOY',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CANTUHAON',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CATIGAHAN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CENTRAL 1 (POB.)',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CENTRAL 2 (POB.)',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'CRUZ',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'DULJUGAN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'GUIWAN 1 (POB.)',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'GUIWAN 2 (POB.)',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'HIMARCO',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'HINABLAYAN POB. (CENTRAL 3)',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'HINAGBUAN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'LAT-OSAN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'LOMONON',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'MASABA',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'MAZAWALO POB. (LILI-ON)',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'PARILLA',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'PINAGDAIT POB. (YPIL I)',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'PINAGHI-USA POB. (YPIL II)',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SAN GUILLERMO',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'TABERNA',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'TABUNOK',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'TAMBIS',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'TINABILAN',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'PALOMPON',
        BARANGAY: 'TINUBDAN',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'ARABUNOG',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'ARINGIT',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'CABAOHAN',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'CALSADAHAY',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'CANCARAJA',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'CANINOAN',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'CAPILLA',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'COLAWEN',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'DISTRICT 1 (POB.)',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'DISTRICT 2 (POB.)',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'DISTRICT 3 (POB.)',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'DISTRICT 4 (POB.)',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'DUMARAG',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'GUINDAPUNAN',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'HALABA',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'JONES',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'LANAWAN',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'LIMA',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'MACALPIAY',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'MALITBOGAY',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'MANAYBANAY',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'MARICUM',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'SAPSAP',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'SOCSOCON',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'TINGIB',
    },
    {
        CITY: 'PASTRANA',
        BARANGAY: 'YAPAD',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'BUTASON I',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'BUTASON II',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'CAMPOKPOK',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'GIBACUNGAN',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'GIMARCO',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'INANGATAN',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'MANLAWAAN',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'OMAGANHAN',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'TABING',
    },
    {
        CITY: 'TABANGO',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'AMANDANGAY',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'ASLUM',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'BALINGASAG',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'BELISONG',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'CAMBUCAO',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'CAPAHUAN',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'DISTRICT I POB. (QUEZON)',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'DISTRICT II POB. (RIZAL)',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'DISTRICT III POB. (BONIFACIO)',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'DISTRICT IV POB. (MACARTHUR)',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'GUINGAWAN',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'JABONG',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'MERCADOHAY',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'MERING',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'MOHON',
    },
    {
        CITY: 'TABONTABON',
        BARANGAY: 'SAN PABLO (MOOC)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 100 (SAN ROQUE)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 101 (NEW KAWAYAN)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 102 (OLD KAWAYAN)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 103 (PALANOG)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 103-A (SAN PAGLAUM)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 104 (SALVACION)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 105 (SUHI)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 106 (SANTO NINO)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 106 (SANTO NIÑO)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 107 (SANTA ELENA)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 108 (TAGAPURO)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 109 (V & G SUBD.)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 109 (V AND G SUBD.)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 109-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 110 (UTAP)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 12 (PALANOG RESETTLEMENT)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 13',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 14',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 15',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 16',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 17',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 18',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 19',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 2',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 20',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 21',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 21-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 22',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 23',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 23-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 24',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 25',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 26',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 27',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 28',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 29',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 30',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 31',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 32',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 33',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 34',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 35',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 35-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 36',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 36-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 37',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 37-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 38',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 39',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 40',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 41',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 42',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 42-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 43',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 43-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 43-B',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 44',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 44-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 45',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 46',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 47',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 48',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 48-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 48-B',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 49',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 5',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 50',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 50-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 50-B',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 51',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 51-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 52',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 53',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 54',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 54-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 56',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 56-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 57',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 58',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 59',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 59-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 59-B',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 5-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 6',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 60',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 60-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 61',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 62',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 62-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 62-B',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 63',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 64',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 65',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 66',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 66-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 67',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 68',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 69',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 6-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 7',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 70',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 71',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 72',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 73',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 74',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 75',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 76',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 77',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 78 (MARASBARAS)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 79 (MARASBARAS)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 8',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 80 (MARASBARAS)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 81 (MARASBARAS)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 82 (MARASBARAS)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 83 (SAN JOSE)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 83-A (SAN JOSE)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 83-B',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 83-C (SAN JOSE)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 84 (SAN JOSE)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 85 (SAN JOSE)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 86',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 87',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 88',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 89',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 8-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 90 (SAN JOSE)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 91 (ABUCAY)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 92 (APITONG)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 93 (BAGACAY)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 94 (TIGBAO)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 94-A',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 95 (CAIBAAN)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 95-A (CAIBAAN)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 96 (CALANIPAWAN)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 97 (CABALAWAN)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 98 (CAMANSINAY)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'BARANGAY 99 (DIIT)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'EL REPOSO (BARANGAYS 55 & 55A)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'EL REPOSO (BARANGAYS 55 AND 55A)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'LIBERTAD (BARANGAYS 1 & 4)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'LIBERTAD (BARANGAYS 1 AND 4)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'NULA-TULA (BGYS. 3 & 3A)',
    },
    {
        CITY: 'TACLOBAN',
        BARANGAY: 'NULA-TULA (BGYS. 3 AND 3A)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'ADA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'AMANLURAN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'ARADO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'ATIPOLO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BANTAGAN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BINOLO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BINONGTO-AN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BISLIG',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'BUNTAY (POB.)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CABALAGNAN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CABARASAN GUTI',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CABONGA-AN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CABUYNAN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CAHUMAYHUMAYAN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CALOGCOG',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CALSADAHAY',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CAMIRE',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CANBALISARA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CANRAMOS (POB.)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CATIGBIAN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'GUINDAG-AN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'GUINGAWAN',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'HILAGPAD',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'KILING',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'LAPAY',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'LICOD (POB.)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'LIMBUHAN DAKU',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'LIMBUHAN GUTI',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MAGAY',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MAGHULOD',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MALAGUICAY',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MARIBI',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'MOHON',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'PAGO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'PASIL',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'PIKAS',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SACME',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SALVADOR',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SAN MIGUEL (POB.)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SAN VICTOR',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SANTO NINO POB. (HACLAGAN)',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'SOLANO',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'TALOLORA',
    },
    {
        CITY: 'TANAUAN',
        BARANGAY: 'TUGOP',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'BURAK',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'CANMOGSAY',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'CANTARIWIS',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'CAPANGIHAN',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'DONA BRIGIDA',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'DOÑA BRIGIDA',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'MALBOG',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'OLOT',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'OPONG',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'QUILAO',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'TANGHAS',
    },
    {
        CITY: 'TOLOSA',
        BARANGAY: 'TELEGRAFO',
    },
    {
        CITY: 'TUNGA',
        BARANGAY: 'ASTORGA (UPART)',
    },
    {
        CITY: 'TUNGA',
        BARANGAY: 'BALIRE',
    },
    {
        CITY: 'TUNGA',
        BARANGAY: 'BANAWANG',
    },
    {
        CITY: 'TUNGA',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'TUNGA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'TUNGA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TUNGA',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'TUNGA',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'TUNGA',
        BARANGAY: 'SANTO NIÑO (POB.)',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'ABIJAO',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'BANGCAL',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'BUGABUGA',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CABUNGAHAN',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CAGNOCOT',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CAHIGAN',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CALBUGOS',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CAMPOROG',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CANQUIASON',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CAPINYAHAN',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CASILI-ON',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'CATAGBACAN',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'FATIMA (POB.)',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'HIBULANGAN',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'HINABUYAN',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'ILIGAY',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'JALAS',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'JORDAN',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'LIBAGONG',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'NEW BALANAC',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'PAYAO',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'SAMBULAWAN',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'SILAD',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'SULPA',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'TABUNOK',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'TAGBUBUNGA',
    },
    {
        CITY: 'VILLABA',
        BARANGAY: 'TINGHUB',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'CAUCAB',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'IYOSAN',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'JAMORAWON',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'LO-OK',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'MATANGA',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'PULANG BATO',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'SALANGI',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'SAMPAO',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'TABUNAN',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'TALAHID',
    },
    {
        CITY: 'ALMERIA',
        BARANGAY: 'TAMARINDO',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'BUSALI',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'CANILA',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'HUGPA',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'JULITA',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'PINANGUMHAN',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'SANGGALANG',
    },
    {
        CITY: 'BILIRAN',
        BARANGAY: 'VILLA ENAGE (BARAS)',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'BALAQUID',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'BASO',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'CAANIBONGAN',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'CASIAWAN',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'ESPERANZA (POB.)',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'LANGGAO',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'MAGBANGON (POB.)',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'PAWIKAN',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'SALAWAD',
    },
    {
        CITY: 'CABUCGAYAN',
        BARANGAY: 'TALIBONG',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'ASUG',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'BARI-IS',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'BINOHANGAN',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'CABIBIHAN',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'CAULANGOHAN (MAREVIL)',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'KAWAYANON',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'MANLABANG',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'MAURANG',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'PALANAY (POB.)',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'PALENGKE (POB.)',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'TOMALISTIS',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'USON',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'VICTORY (POB.)',
    },
    {
        CITY: 'CAIBIRAN',
        BARANGAY: 'VILLA VICENTA (MAINIT)',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'ACABAN',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'BINONGTOAN',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'BOOL CENTRAL (POB.)',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'BOOL EAST (POB.)',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'BOOL WEST (POB.)',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'CALIPAYAN',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'CULABA CENTRAL (POB.)',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'GUINDAPUNAN',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'HABUHAB',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'MARVEL (POB.)',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'PINAMIHAGAN',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CULABA',
        BARANGAY: 'VIRGINIA (POB.)',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'BAGANITO',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'BALACSON',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'BILWANG',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'BULALACAO',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'INASUYAN',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'KANSANOK',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'MADA-O',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'MAPUYO',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'MASAGAOSAO',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'MASAGONGSONG',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'TABUNAN NORTH',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'TUBIG GUINOO',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'TUCDAO',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'UNGALE',
    },
    {
        CITY: 'KAWAYAN',
        BARANGAY: 'VILLA CORNEJO (LOOC)',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'AGUTAY',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'BANLAS',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'BINALAYAN EAST',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'BINALAYAN WEST',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'BINONGTO-AN (POBLACION NORTE)',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'CALBANI',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'CANDUHAO',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'CASIBANG',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'ERMITA (POBLACION SUR)',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'OL-OG',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'TRABUGAN',
    },
    {
        CITY: 'MARIPIPI',
        BARANGAY: 'VIGA',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'AGPANGI',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'ANISLAGAN',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'ATIPOLO',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'BORAC',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'CABUNGAAN',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'CAPINAHAN',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'CARAYCARAY',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'HAGUIKHIKAN',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'LARRAZABAL',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'LICO',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'LUCSOON',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'PADRE INOCENTES GARCIA (POB.)',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'PADRE SERGIO EAMIGUEL',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'SANTISSIMO ROSARIO POB. (SANTO ROSA)',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'TALUSTUSAN',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'VILLA CANEJA',
    },
    {
        CITY: 'NAVAL',
        BARANGAY: 'VILLA CONSUELO',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'BALUD (POB.)',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'BATO (SAN LUIS)',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'BERI',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'BIGO',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'CAGSALAY',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'CAMPACION',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'CARAPDAPAN',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'CASIDMAN',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'CATUMSAN',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'GARDEN (POB.)',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'INAYAWAN',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'MACARTHUR',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'RAWIS (POB.)',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'TANGBO',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'TAWAGAN',
    },
    {
        CITY: 'ARTECHE',
        BARANGAY: 'TEBALAWON',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'BACJAO',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'BARANGAY POBLACION I',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'BARANGAY POBLACION II',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'BARANGAY POBLACION III',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'BARANGAY POBLACION IV',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'BARANGAY POBLACION V',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'BARANGAY POBLACION VI',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'CAG-OLANGO',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'CANSUMANGCAY',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'GUINMAAYOHAN',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'MAYBUNGA',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BALANGIGA',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'CABAY',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'CAISAWAN',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'CANTUBI',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'GENERAL MALVAR',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'GUINPOLIRAN',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'JULAG',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'MARAMAG',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'POBLACION IV',
    },
    {
        CITY: 'BALANGKAYAN',
        BARANGAY: 'POBLACION V',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'AMANTACOP',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'ANDO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'BALACDAS',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'BANUYO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'BAYOBAY',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'BENOWANGAN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'BUGAS',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CABALAGNAN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CABONG',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CAGBONGA',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CALICO-AN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CALINGATNGAN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CAMADA',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CAMPESAO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CAN-ABONG',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CAN-AGA',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CANJAWAY',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CANLARAY',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'CANYOPAY',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'DIVINUBO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'HEBACONG',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'HINDANG',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'LALAWIGAN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'LIBUTON',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'LOCSO-ON',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'MAYBACONG',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'MAYPANGDAN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PEPELITAN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PINANAG-AN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUNTA MARIA',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUROK A (POB.)',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUROK B (POB.)',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUROK C (POB.)',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUROK D1 (POB.)',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUROK D2 (POB.)',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUROK E (POB.)',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUROK F (POB.)',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUROK G (POB.)',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'PUROK H (POB.)',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SABANG NORTH',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SABANG SOUTH',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SAN SATURNINO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SIHA',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SOHUTAN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SONGCO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SURIBAO',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'SUROK',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'TABOC',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'TABUNAN',
    },
    {
        CITY: 'BORONGAN',
        BARANGAY: 'TAMOSO',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BALAGON',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 1 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 10 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 2 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 3 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 4 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 5 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 6 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 7 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 8 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARANGAY 9 POBLACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BARUK',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'BOCO',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'CAGHALONG',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'CAMANTANG',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'CAN-ILAY',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'CANSANGAYA',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'CANTEROS',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'CAROLINA',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'GUIBUANGAN',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'JEPACO',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'MALOGO',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'OBONG',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'PANDOL',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CAN-AVID',
        BARANGAY: 'SOLONG',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'AROGANGA',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 13 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 14 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 15 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BONGHON',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'CABAGO-AN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'CAGLAO-AN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'CAGTABON',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'DAMPIGAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'DENIGPIAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'GAP-ANG',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'HILABAAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'HINOLASO',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'JAPITAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'JICONTOL',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'MAGONGBONG',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'MALAINTOS',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SAN ISIDRO (MALABAG)',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'TANAUAN',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'TIKLING',
    },
    {
        CITY: 'DOLORES',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 1',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 10',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 2',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 3',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 4',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 5',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 6',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 7',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 8',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BARANGAY POBLACION 9',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BETAOG',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'BOLUSAO',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'GUINOB-AN',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'MASLOG',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LAWAAN',
        BARANGAY: 'TAGUITE',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'ANURON',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BANUYO',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY 1 POBLACION',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY 2 POBLACION',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY 3 POBLACION',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BARANGAY 4 POBLACION',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BOBON',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'BUYAYAWON',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'CAMBANTE',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'PALAMRAG (CABILIRI-AN)',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'PORT KENNEDY',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MERCEDES',
        BARANGAY: 'SUNG-AN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'ABEJAO',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'ALOG',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'ASGAD',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BAGTONG',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 13 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BUABUA',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BURAK',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BUTIG',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'CAGAUT',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'CAMANGA',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'CANTOMOJA',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'CARAPDAPAN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'CASILI-ON',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'IBERAN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'JAGNAYA',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'LUSOD',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'MALBOG',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'MALIWALIW',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'MATARINAO',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'NAPARAAN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'SAN ROQUE (BUGAY)',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'SEGUINON',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'TACLA-ON',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'TAGBACAN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'TALANGDAWAN',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'BINALAY',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'CALUTAN',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'CAMCUEVAS',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'DOMROG',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'LAUREL',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'LIMBUJAN',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'MACAPAGAL',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'PINGAN',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'POBLACION BARANGAY 1',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'POBLACION BARANGAY 2',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'POBLACION BARANGAY 3',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'POBLACION BARANGAY 4',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'POBLACION BARANGAY 5',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'POBLACION BARANGAY 6',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'POBLACION BARANGAY 7',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'POBLACION BARANGAY 8',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'SANTA CRUZ (OPONG)',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'TANDANG SORA',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'TUGOP',
    },
    {
        CITY: 'GENERAL-MACARTHUR',
        BARANGAY: 'VIGAN',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'COTICOT',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'GIGOSO',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'HUKNAN',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'PARINA',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'PAYA',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'PRESIDENT ROXAS',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'SAN ISIDRO (MALABAG)',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'GIPORLOS',
        BARANGAY: 'SANTA CRUZ (CANSINGKOL)',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'ALINGAROG',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'BAGUA',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'BANAAG',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'BANAHAO',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'BARBO',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'BITAUGAN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'BUCAO',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'BUNGTOD',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'CAGDARA-O',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'CAGUSU-AN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'CAMPARANG',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'CAMPOYONG',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'CANAWAYON',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'CANTAHAY',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'CASUGURAN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'CULASI',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'DALARAGAN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'GAHOY',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'HABAG',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'HAGNA',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'HAMORAWON',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'HOLLYWOOD',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'INAPULANGAN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'LUPOK (POB.)',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'MAYANA',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'NGOLOS',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'PAGBABANGNAN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'PAGNAMITAN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 1',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 10',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 11',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 12',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 2',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 3',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 4',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 4-A',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 5',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 6',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 7',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 8',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 9',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'POBLACION WARD 9-A',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SALUG',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SAPAO',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SULANGAN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SULUAN',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'SUROK',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'TAGPORO',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'TIMALA',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'TRINIDAD',
    },
    {
        CITY: 'GUIUAN',
        BARANGAY: 'VICTORY ISLAND',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'BATANG',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'CACATMONAN',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'CANCILEDES',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'GARAWON',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'NAGAJA',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'PADANG',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'HERNANI',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'AGSAMAN',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'CAGMANABA',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'DORILLO',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'JEWARAN',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'RECARE',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'JIPAPAD',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BABANIKHON',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BACAYAWAN',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BAROBO',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'BURAK',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'CAN-ATO',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'CANDOROS',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'CANLIWAG',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'CANTOMCO',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'HUGPA',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'MACA-ANGA',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'MAGTINO',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'MINA-ANOD',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'NAUBAY',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'PILIW',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'SO-ONG',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'TABOK',
    },
    {
        CITY: 'LLORENTE',
        BARANGAY: 'WASO',
    },
    {
        CITY: 'MANDOLONG',
        BARANGAY: 'BARANGAY POBLACION 1',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'CARAYACAY',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'MAPUTI',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'TANGBO',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'MASLOG',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'BARANGAY POBLACION 1',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'BARANGAY POBLACION 2',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'BARANGAY POBLACION 3',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'BARANGAY POBLACION 4',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'BARANGAY POBLACION 5',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'BARANGAY POBLACION 6',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'BARANGAY POBLACION 7',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'CAMADA',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'CAMPAKERIT (BOTAY)',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'CANLOTERIO',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'GUINDALITAN',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'LAPGAP',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'MAYBOCOG',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'MAYTIGBAO',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'OMAWAS',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'MAYDOLONG',
        BARANGAY: 'TAGASLIAN',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'AGSAM',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BALINGASAG',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BALOCAWE (POB.)',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BATANG',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BINALAYAN',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BUNTAY',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BURAK',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'BUTNGA (POB.)',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'CADIAN',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'CAGDINE',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'CAGPILE',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'CAGTOOG',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'CAMANGA (POB.)',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'DALID',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'FACTORIA',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'GAMOT',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'IWAYAN',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'JAPAY',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'KALAW',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'MALINGON',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'MINAP-OS',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'NADACPAN',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'NAGA',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'PANGUDTAN',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'PAYPAYON (POB.)',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'RIVERSIDE (POB.)',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'SAN EDUARDO',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'SAUGAN',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'SAURONG',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'TAWAGAN (POB.)',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'TIGUIB (POB.)',
    },
    {
        CITY: 'ORAS',
        BARANGAY: 'TRINIDAD (MAYCOROT)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'ANISLAG',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'BAGTE',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'BARANGAY NO. 1 (POB.)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'BARANGAY NO. 2 (POB.)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'BARANGAY NO. 3 (POB.)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'BARANGAY NO. 4 (POB.)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'BARANGAY NO. 5 (POB.)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'BARANGAY NO. 6 (POB.)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'BARANGAY NO. 7 (POB.)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'CACULANGAN',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'CAGDAJA',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'CAMBILLA',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'CANTENIO',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'NAGA',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'PACO',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'PALACTAD (VALLEY)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'RIZAL (PANA-UGAN)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'SANTA CRUZ (LORO DIYO)',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'SANTA MARGARITA',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'QUINAPONDAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'BARANGAY NO. 1 POBLACION',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'BARANGAY NO. 2 POBLACION',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'BARANGAY NO. 3 POBLACION',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'BARANGAY NO. 4 POBLACION',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'BARANGAY NO. 5 POBLACION',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'BARANGAY NO. 6 POBLACION',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'BUNACAN',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'CAMPIDHAN',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'CASOROY',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'LUNANG',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'NENA (LUNA)',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'PAGBABANGNAN',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'PUTONG',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-JULIAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'ALUGAN',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'BARANGAY NO. 1 (POB.)',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'BARANGAY NO. 2 (POB.)',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'BARANGAY NO. 3 (POB.)',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'BARANGAY NO. 4 (POB.)',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'BARANGAY NO. 5 (POB.)',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'BARAS (LIPATA)',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'BINOGAWAN',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'CAJAGWAYAN',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'JAPUNAN',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'NATIVIDAD',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'TABO',
    },
    {
        CITY: 'SAN-POLICARPO',
        BARANGAY: 'TAN-AWAN',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'ABUCAY (POB.)',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'A-ET',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'BAYBAY (POB.)',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'DEL REMEDIO',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'KANDALAKIT',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'LOYOLA HEIGHTS (POB.)',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'MAGLIPAY (POB.)',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'MARAMARA (POB.)',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'RIVERSIDE (POB.)',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'SULAT',
        BARANGAY: 'TABI (POB.)',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'BATIAWAN',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'BETO',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'BINALOAN',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'BONGDO',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'DACUL',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'DEL REMEDIOS',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'GAYAM',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'LOMATUD (BURAK)',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'MANTANG',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'NATO',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'PANGABUTAN',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'POBLACION BARANGAY 1',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'POBLACION BARANGAY 2',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'POBLACION BARANGAY 3',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'POBLACION BARANGAY 4',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'POBLACION BARANGAY 5',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'POBLACION BARANGAY 6',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'POLANGI',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'TAFT',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'ALEJANDRO VILLAGE (SANTIAGO)',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'CABACUNGAN',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'CALARAYAN',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'FREDERIC',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'GUIN-ARAWAYAN',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'JUBASAN',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'KINABRANAN ZONE I (POB.)',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'KINABRANAN ZONE II (POB.)',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'KINAGUITMAN',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'LAGUNDI',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'LONDRES',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'LO-OC',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'SABANG ZONE I (POB.)',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'SABANG ZONE II (POB.)',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'TASVILLA',
    },
    {
        CITY: 'ALLEN',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'BIRI',
        BARANGAY: 'KAUSWAGAN (BASUD)',
    },
    {
        CITY: 'BIRI',
        BARANGAY: 'MACARTHUR',
    },
    {
        CITY: 'BIRI',
        BARANGAY: 'PIO DEL PILAR',
    },
    {
        CITY: 'BIRI',
        BARANGAY: 'POBLACION (BIRI)',
    },
    {
        CITY: 'BIRI',
        BARANGAY: 'PROGRESSO',
    },
    {
        CITY: 'BIRI',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BIRI',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BIRI',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BIRI',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'ACERIDA',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'ARELLANO',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'BALAT-BALUD',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'CALANTIAO (PANGOBI-AN)',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'DANCALAN',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'E. DURAN',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'GEN. LUCBAN (POB.)',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'JOSE ABAD SANTOS',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'JOSE P. LAUREL (CASULGAN)',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'MAGSAYSAY (DOCE)',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'QUEZON (PANICAYAN)',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'SANTA CLARA (POB.)',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'SANTANDER',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'SOMOROY',
    },
    {
        CITY: 'BOBON',
        BARANGAY: 'TROJELLO',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'AGUIN',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'JUBANG',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'LANDUSAN',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'OSON',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'POBLACION BARANGAY 1',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'POBLACION BARANGAY 2',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'POBLACION BARANGAY 3',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'POBLACION BARANGAY 4',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'POBLACION BARANGAY 5',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'SAGAOSAWAN',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'CAPUL',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'ANONGO',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'BORING',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'CAGBUGNA',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'CAGMANABA',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'CAGOGOBNGAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'CALINGNAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'CANUCTAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'CLARO M. RECTO (LOBEDICO)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'D. MERCADER (BONGOG)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'GUIBWANGAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'HINAGONOYAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'HIPARAYAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'HITAPI-AN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'INOBURAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'IRAWAHAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'LENOYAHAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'LIBON',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'MAGONGON',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'MAGTUAD',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'MANERING',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'NABULO',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'NAGOOCAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'NAHULID',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'OPONG',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'OSANG',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'P. REBADULLA',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'SAGUDSURON',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'SAN JOSE (HEBOBOLLAO)',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'SULITAN',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'TANGBO',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'TUNGODNON',
    },
    {
        CITY: 'CATUBIG',
        BARANGAY: 'VIENNA MARIA',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'ANITO',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'BAYBAY DISTRICT (POB.)',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'BURABOD (POB.)',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'CABARASAN',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'CADAC-AN (CALINGNAN)',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'CADE-AN',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'CAGAMUTAN DEL NORTE',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'CAGAMUTAN DEL SUR',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'G. M. OSIAS',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'GAMAY CENTRAL (POB.)',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'GAMAY OCCIDENTAL I (POB.)',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'GAMAY ORIENTAL I (POB.)',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'GUIBUANGAN',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'HENOGAWE',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'LIBERTAD (POB.)',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'LONOY',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'LUNETA',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'MALIDONG',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'OCCIDENTAL II (POB.)',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'ORIENTAL II (POB.)',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'GAMAY',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'ABATON',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'AGUADAHAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'AROGANGA',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'ATIPOLO',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'BAWANG',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'BAYBAY (POB.)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'BINATIKLAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'BOBOLOSAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'BONGLIW',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'BURABUD',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CABAGNGAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CABAGO-AN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CABULALOAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CAGAASAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CAGDARA-O',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CAHAYAGAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CALINTAAN POB. (STO. NINO)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CALOMOTAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CANDAWID',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CANGCAHIPOS',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CANYOMANAO',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'CATIGBIAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'E. J. DULAY',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'G. B. TAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'GIBATANGAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'GUILAOANGI (POB.)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'INAMLAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'LA PERLA',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'LANGOB',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'LITTLE VENICE (POB.)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'MARUBAY',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'MUALBUAL',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'NAPOTIOCAN (SALVACION)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'OLERAS',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'ONAY (DONA LUISA)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'PALMERA',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'PANGDAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'ROMBANG',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'SAN ANTONIO (SON-OG)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'SAN MIGUEL HEIGHTS (POB.)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'SANGCOL',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'SIBUNOT',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'SIMORA',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'TAN-AWAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'TARUSAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'TINOBLAN',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'TUMAGUINGTING (POB.)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'VIGO',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'YABYABAN (SAN VICENTE)',
    },
    {
        CITY: 'LAOANG',
        BARANGAY: 'YAPAS',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'CAHAGWAYAN',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'CAN MARIA',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'CAN OMANIO',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'LAPINIG DEL NORTE (POB.)',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'LAPINIG DEL SUR (POB.)',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'LO-OK',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'MAY-IGOT',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'PIO DEL PILAR',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'POTONG',
    },
    {
        CITY: 'LAPINIG',
        BARANGAY: 'POTONG DEL SUR',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'BUGAY',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'BUGTOSAN',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'BUKID',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'BULAO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'CAPUTOAN',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'CATOTO-OGAN',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'CUENCO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'EPAW',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'GEGUINTA',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'GERACDO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'GUYO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'H. JOLEJOLE',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'H. JOLEJOLE DISTRICT (POB.)',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'HANGI',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'L. EMPON',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'LAKANDULA',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'LUMALA-OG',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'MACARTHUR',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'MATELARAG',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'PACO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'PEREZ',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'POPONTON',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'QUIRINO DISTRICT (POB.)',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'REBONG',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'RUFINO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SAG-OD',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SAN JORGE',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'TAGAB-IRAN',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'TAGAN-AYAN',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'TAYLOR',
    },
    {
        CITY: 'LAS-NAVAS',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'BALICUATRO',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'BANI',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'BAROBAYBAY',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'CABURIHAN (POB.)',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'CARAGAS (POB.)',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'CATAOGAN (POB.)',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'CHANSVILLA',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'DATAG',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'ENRIQUETA',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'MACARTHUR',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'MARAVILLA',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'OCAD (POB.)',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'SABONG-TABOK',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'TO-OG',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'URDANETA',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'VILLA',
    },
    {
        CITY: 'LAVEZARES',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'BAYHO',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'CAG-AGUINGAY',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'CAGAMESARAG',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'CURRY',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'GEBONAWAN',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'GEN. LUNA',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'GETIGO',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'HENARONAGAN',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'LOPE DE VEGA (POB.)',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'LOWER CAYNAGA',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'MAGHIPID',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'PAGUITE',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'SOMOROY',
    },
    {
        CITY: 'LOPE-DE-VEGA',
        BARANGAY: 'UPPER CAYNAGA',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'DEL NORTE (POB.)',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'DEL SUR (POB.)',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'E. LAODENIO',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'JUBASAN',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'MAGTAON',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'MANAYBANAY',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'NAPARASAN',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'SANTA POTENCIANA (POB.)',
    },
    {
        CITY: 'MAPANAS',
        BARANGAY: 'SILJAGON',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'BAGASBAS',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'BUGKO',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'CABLANGAN',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'CAGMANABA',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'CAHICSAN',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'CHITONGCO (POB.)',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'DE MARIA',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'DONA LUCIA',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'ECO (POB.)',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'FLORMINA',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'HINABANGAN',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'LA TRINIDAD',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'MAKIWALO',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'MIRADOR',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'NENITA',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'MONDRAGON',
        BARANGAY: 'TALOLORA',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'ACACIA (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'AIRPORT VILLAGE',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'BANGKEROHAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'BOCSOL',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'CABAYHAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'CAG-ABACA',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'CALACHUCHI (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'CAL-IGANG',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'CERVANTES',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'CULARIMA',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'DAGANAS',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'DALAKIT (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'DONA PULQUERIA (HIMBANG)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'GALUTAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'GEBALAGNAN (HIBALAGNAN)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'GEBULWANGAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'GENERAL MALVAR',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'GUBA',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'HINATAD',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'IMELDA (ELIMBO)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'IPIL-IPIL (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'JOSE ABAD SANTOS (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'JOSE P. RIZAL (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'KASOY (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'LAPU-LAPU (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'LIBJO (BINOG)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'MABOLO (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'MACAGTAS',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'MCKINLEY',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'MOLAVE (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'NARRA (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'NEW RIZAL',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'OLD RIZAL',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'PATICUA',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'POLANGI',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'SAMPAGUITA (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'SANTOL (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'SOMOGE',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'TALISAY (POB.)',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'TINOWARAN',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'TRANGUE',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'UEP I',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'UEP II',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'UEP III',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'WASHINGTON',
    },
    {
        CITY: 'CATARMAN',
        BARANGAY: 'YAKAL (POB.)',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'AGUADA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BANTOLINAO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'COMMONWEALTH',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'GUINDAULAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'JAMOOG',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'KAILINGAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SALHAG',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'DALUPIRIT',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'MANRAYA',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'VINISITAHAN',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'WARD I (POB.)',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'WARD II (POB.)',
    },
    {
        CITY: 'SAN-ANTONIO',
        BARANGAY: 'WARD III (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CAGLANIPAO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'HAPPY VALLEY',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'PALANIT',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SEVEN HILLS',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'VERIATO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'AGUADAHAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BAGONG SABANG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY EAST (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY NORTH (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY SOUTH (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY WEST (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BONGLAS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DA-O',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'GENGAROG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'GERATAG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LAYUHAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MANDUGANG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'P. TINGZON',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TUBIGDANAO',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'DESTACADO POB. (BGY.2)',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'MARAGAT',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'MONGOL BONGOL POB. (BGY.1)',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'PUNTA POB. (BGY.3)',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'SANGPUTAN',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'SILA',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'TARNATE',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'ACEDILLO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'BUENOS AIRES',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'COLAB-OG',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'ERENAS',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'LUISITA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'LUNGIB',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'MAXVILLA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'PASABUENA',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN LAZARO',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'SAN ROMAN',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'VICTORIA',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'ASUM (POB.)',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'BENIGNO S. AQUINO',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'BENIGNO S. AQUINO JR.',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'BINAY',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'CABARIWAN',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'CABATUAN',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'CAMPEDICO',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'CAPACUJAN',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'JANGTUD',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'LANIWAN (POB.)',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'MABARAS',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'MANAJAO',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'MAPNO',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'MARAGANO',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'MATAMBAG',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'MONBON',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'NAGBOBTAC',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'NATAWO',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'NIPA',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'PAYSUD',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'SANGAY',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'SIMORA',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'SINALARAN',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'SUMOROY',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'TALOLORA',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'TAMBANGAN (POB.)',
    },
    {
        CITY: 'PALAPAG',
        BARANGAY: 'TINAMPO (POB.)',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'CABABTO-AN',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'CABARI-AN',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'CAGBIGAJO',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'CAMPARANGA',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'CANJUMADAL',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'DONA ANECITA',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'GE-ADGAWAN',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'GEPARAYAN',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'GINULGAN',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'IGOT',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'INANAHAWAN',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'MANAHAO',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'PANINIRONGAN',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'POBLACION DISTRICT 1',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'POBLACION DISTRICT 2',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'POBLACION DISTRICT 3',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'POBLACION DISTRICT 4',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'POBLACION DISTRICT 5',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'POBLACION DISTRICT 6',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'POBLACION DISTRICT 7',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'POBLACION DISTRICT 8',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'SENONOGAN',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'SIXTO T. BALANGUIT',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'SIXTO T. BALANGUIT SR.',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'TULA',
    },
    {
        CITY: 'PAMBUJAN',
        BARANGAY: 'YNAGUINGAYAN',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'BALNASAN',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'COROCONOG',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'DALE',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'GINAGDANAN',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'LAO-ANGAN',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'PAGSANG-AN',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'ZONE 1 (POB.)',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'ZONE 2 (POB.)',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'ZONE 3 (POB.)',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'ZONE 4 (POB.)',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'ZONE 5 (POB.)',
    },
    {
        CITY: 'SAN-ROQUE',
        BARANGAY: 'ZONE 6 (POB.)',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'CABABAYOGAN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'CAGDA-O',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'CAGHILOT',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'CAMANGGARAN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'CAMAYA-AN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'DEIT DE SUBA',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'DEIT DE TURAG',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'GEBOLWANGAN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'GEBONAWAN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'GECBO-AN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'GENAGASAN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'GEPARAYAN DE TURAG',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'GIGUIMITAN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'GUSARAN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'MONTALBAN',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'SENONOGAN DE TUBANG',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'SUBA (POB.)',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'TOBGON',
    },
    {
        CITY: 'SILVINO-LOBOS',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'AMAGUSAN',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'CALINTAAN',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'CANLABIAN',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'CAPACUHAN',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'KAGINGKINGAN',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'LEWING',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'LO-OK',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'MAHALO',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'MANIGAWONG',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ANAHAWAN',
        BARANGAY: 'TAGUP-ON',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'AMBACON',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'BADIANGON',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'BANGCAS A',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'BANGCAS B',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'CALAG-ITAN',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'CALAYUGAN',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'CALINAO',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'CANIPAAN',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'CATUBLIAN',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'INGAN',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'LABRADOR',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'LUMBOG',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'MANALOG',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'MANLICO',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'MATIN-AO',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'NAVA',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'NUEVA ESPERANZA',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'OTAMA',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'PALONGPONG',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'PANALARON',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'PONDOL',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'SALOG',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'SAN PABLO ISLAND',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'SAN PEDRO ISLAND',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'SANTO NINO I',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'SANTO NINO II',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'TAHUSAN',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'TAWOG',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'TOPTOP',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'HINUNANGAN',
        BARANGAY: 'UPPER BANTAWON',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'AMAGA',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'AMBAO',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'AN-AN',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'BACULOD',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'CABULISAN',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'CAT-IWING',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'HUBASAN',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'LUNGSODAAN',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'NAVALITA',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'HINUNDAYAN',
        BARANGAY: 'SAGBOK',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'BOGASONG',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'GAKAT',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'JUBAS (POB.)',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'MAGKASAG',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'MAYUGA',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'NAHAONG',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'NAHULID',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'OTIKON',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'TALISAY (POB.)',
    },
    {
        CITY: 'LIBAGON',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'LIMASAWA',
        BARANGAY: 'CABULIHAN',
    },
    {
        CITY: 'LIMASAWA',
        BARANGAY: 'LUGSONGAN',
    },
    {
        CITY: 'LIMASAWA',
        BARANGAY: 'MAGALLANES',
    },
    {
        CITY: 'LIMASAWA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'LIMASAWA',
        BARANGAY: 'SAN BERNARDO',
    },
    {
        CITY: 'LIMASAWA',
        BARANGAY: 'TRIANA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'ABGAO (POB.)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'ACASIA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'ASUNCION',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BACTUL I',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BACTUL II',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BAGTICAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BATO I',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BATO II',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BAUGO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BILIBOL',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BOGO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CABULIHAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CAGNITUAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CAMBOOC',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CANSIRONG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CANTURING',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CANYUOM',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'COMBADO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'DONGON',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'GAWISAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'HANGINAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'HANTAG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'HINAPU DAKU',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'HINAPU GAMAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'IBARRA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'ISAGANI',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LABOON',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LIBHU',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LIB-OG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LONOY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LUNAS',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MALAPOC NORTE',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MALAPOC SUR',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MAMBAJAO (POB.)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MANHILO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MANTAHAN (POB.)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MARIA CLARA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MATIN-AO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NASAUG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NATI',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NONOK NORTE',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NONOK SUR',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PANAN-AWAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PANSAAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PASAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PINASCOHAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SORO-SORO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TAGNIPA (POB.)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TAM-IS',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TAWID',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TIGBAWAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TOMOY-TOMOY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TUNGA-TUNGA (POB.)',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'AMPARO',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'ASUNCION',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'BUSCAYAN',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'CAMBARO',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'CANLUSAY',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'FLORDELIZ',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'ICHON',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'LARAY',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'LOWER VILLA JACINTA',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'MOHON',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'MOLOPOLO',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SALVADOR (MANGYANG)',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SAN VICENTE (UPPER SAN ROQUE)',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SAN VICENTE POBLACION',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SANTO ROSARIO (POB.)',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'SINDANGAN',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'UPPER ICHON',
    },
    {
        CITY: 'MACROHON',
        BARANGAY: 'UPPER VILLA JACINTA',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'BALONGBALONG',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'CANLAWIS',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'CATBAWAN',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'CAUBANG',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'DAN-AN',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'LOBO',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'MANGLIT',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'NUEVA ESTRELLA NORTE',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'NUEVA ESTRELLA SUR',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'POBLACION IBABAO',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'POBLACION UBOS',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'POCIANO D. EQUIPILAG',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'PONOD',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'SON-OK I',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'SON-OK II',
    },
    {
        CITY: 'PINTUYAN',
        BARANGAY: 'TAUTAG',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'ATUYAN',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'AYAHAG',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'BANTAWON',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'BOLODBOLOD',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'CABAGAWAN',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'CARNAGA',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'GUINSAUGON',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'HIMATAGON (POB.)',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'HIMBANGAN',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'HIMOS-ONAN',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'HINABIAN',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'HINDAG-AN',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'LIPANTO',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'MAGATAS',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'MAGBAGACAY',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'MALIBAGO',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'NUEVA ESPERANZA (CABAC-AN)',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'PANIAN',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'SUG-ANGON',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'TABONTABON',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'TAMBIS I',
    },
    {
        CITY: 'SAINT-BERNARD',
        BARANGAY: 'TAMBIS II',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'BENIT',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'BITOON',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'CABUTAN',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'CAMANG',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'ESPERANZA DOS',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'INOLINAN',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'KINACHAWA',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'PINUT-AN',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'SAN ANTONIO (ALANGALANG)',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'SAUB',
    },
    {
        CITY: 'SAN-RICARDO',
        BARANGAY: 'TIMBA',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'BALAGAWAN',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'HINGATUNGAN',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'LAGUMA',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'POB. DISTRICT I',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'POB. DISTRICT II',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'PUNTANA',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'SAP-ANG',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'SUDMON',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'TUBA-ON',
    },
    {
        CITY: 'SILAGO',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'ANAHAO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'BANAHAO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'BAUGO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'BENITON',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'CASAO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'CATOOGAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'CAWAYANAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'GUINSANGAAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'HIBAGWAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'HILAAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'HIMAKILO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'HITAWOS',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'LAWGAWAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'MALBAGO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'MAUYLAB',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'OLISIHAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'PAKU',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'PAMAHAWAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'PAMIGSIAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'PONG-ON',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'SAMPONGON',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'TAA',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'TAYTAGAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'BONTOC',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'AMAGA',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'ANILAO',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'CAGBUNGALON',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'CALIAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'CALIGANGAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'CANDAYUMAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'CATIG',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'ESTELA',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'GUD-AN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'GUINTOYLAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'HIMAYANGAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'ILAG',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'MAGAUPAS',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'MALANGSA',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'MOLOPOLO',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'PRES. QUEZON (MAUGOC)',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'PRESIDENT ROXAS',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'TABUGON',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'ABAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'ABILAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'AGROCEL POB.(AGUINALDO-ROXAS--CELSO MAYOR)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'AMERANG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BAGACAY EAST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BAGACAY WEST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BUG-OT',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BULAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BUNTALAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BURAK',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CABANGCALAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CABATAC',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CAIGON',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CANANGHAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CANAWILI',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'DAGAMI',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'DAJA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'DALUSAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'DELCAR POB.(DELGADO-CARTAGENA)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'INABASAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LAYOG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LINAB',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LINAGAN CALSADA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LINAGAN TACAS',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MANDOG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MARI POB. (MABINI-RIZAL)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MIAPA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NAGBA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NASAKA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NASLO-BUCAO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NASULI',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PANALIAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PIANDAAN EAST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PIANDAAN WEST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PISPIS',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SINUBSUBAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SIWALO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SUBOG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'THTP POB.(TAFT-THOMPSON--HUGHES-DEL PILAR)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TIGBAUAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TRANGKA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TUBANG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TULAHONG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TUY-AN EAST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TUY-AN WEST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'UBIAN',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'ABGAO',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'ASUNCION',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'BENIT',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'CAAGA',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'CABUL-ANONAN (POB.)',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'CADARUHAN',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'CADARUHAN SUR',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'CANDATAG',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'CANTAMUAC',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'CARAATAN',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'GUINABONAN',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'JUANGON',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'LAMBONAO',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'MANINGNING',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'MAUJO',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'NEW KATIPUNAN',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'PANCIL',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'PASIL (POB.)',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SANGAHON',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'TALIWA (POB.)',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'TIGBAWAN I',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'TIGBAWAN II',
    },
    {
        CITY: 'MALITBOG',
        BARANGAY: 'TIMBA',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'CANTUTANG',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'DINAHUGAN',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'LACA',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'LUNGSODAAN',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'SANTA SOFIA',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'PADRE-BURGOS',
        BARANGAY: 'TANGKAAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'ANISLAGON',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BONGAWISAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BONGBONG',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CAHAYAG',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CAUSI',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'DAKIT (POB.)',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'GABI',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'HABAY',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'MALICO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'MARAYAG',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'NAPANTAO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'PASANON',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'PINAMUDLAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SANTA PAZ NORTE',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SANTA PAZ SUR',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SUDMON',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'TINAAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'TUNO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'UBOS (POB.)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'AGAY-AY',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BOBON A',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BOBON B',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'DAYANOG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'GARRIDO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'MINOYHO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'OSAO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PONG-OY',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SANTO NINO (POB.)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SANTO NIÑO (POB.)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SOMOJE',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TIMBA',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'BENIT',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'BUAC DAKU',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'BUAC GAMAY',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'CABADBARAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'DAGSA',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'HIBOD-HIBOD',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'HINDANGAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'HIPANTAG',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'JAVIER',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'KAHUPIAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'KANANGKAAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'LA PURISIMA CONCEPCION',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'LUM-AN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'MABICAY',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'MAC',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'MAGATAS',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'MARIA PLANA',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'MILAGROSO',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'OLISIHAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'PANCHO VILLA',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SAN FRANCISCO MABUHAY',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SAN JUAN (AGATA)',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'TAMPOONG',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'ZONE V (POB.)',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'ANAHAWAN',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'BANDAY (POB.)',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'BOGO (POB.)',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'CABASCAN',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'CAMANSI',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'CAMBITE (POB.)',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'CANLUPAO',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'CARNAGA',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'HIGOSOAN',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'HINAGTIKAN',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'HINAPO',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'HUGPA',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'INIGUIHAN POB. (SALVACION)',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'LUAN',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'MAANYAG',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'MAG-ATA',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'MAPGAP',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'MASLOG',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'PONONG',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TOMAS-OPPUS',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'AMANDAYEHAN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'ANGLIT',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BACUBAC',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BALANTE',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BALOOG',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BASIAO',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BAYBAY (POB.)',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BINONGTU-AN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BULAO',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'BUSCADA (POB.)',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'CAMBAYAN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'CAN-ABAY',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'CANCAIYAS',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'CANMANILA',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'CATADMAN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'DOLONGAN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'GUINTIGUI-AN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'GUIRANG',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'INUNTAN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'LAWA-AN (POB.)',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'LOOG',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'LOYO (POB.)',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'MAGALLANES',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'MANLILINAB',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'MAY-IT',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'MERCADO (POB.)',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'MONGABONG',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'NEW SAN AGUSTIN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'NOUVELAS OCCIDENTAL',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'OLD SAN AGUSTIN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'PALAYPAY (POB.)',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'PANUGMONON',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'PELIT',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'SAN FERNANDO (NOUVELAS ORIENTAL)',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'SAWA',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'SERUM',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'SUGCA',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'SUGPONON',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'SULOD (POB.)',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'TINAOGAN',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'TINGIB',
    },
    {
        CITY: 'BASEY',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'ACEDILLO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'AGUIT-ITAN (POB.)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'ALIBABA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'AMAMPACANG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'ANISLAG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'AWANG EAST (POB.)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'AWANG WEST (POB.)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BA-AY',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BAGONG LIPUNAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BAJA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BALUD (POB.)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BANTE',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BANTIAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BASUD',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BAYO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BEGAHO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BINALIW',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BONTAY',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'BUGTONG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CABACUNGAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CABATUAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CABICAHAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CABUGAWAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CACARANSAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAG-ANAHAW',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAG-ANIBONG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAGBANAYACAO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAGBAYANG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAGBILWANG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAGBOBORAC',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAGLANIPAO SUR',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAGMANIPES NORTE',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAGMANIPES SUR',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAGNIPA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAG-OLANGO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAGSALAOSAO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAHUMPAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CALOCNAYAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CANGOMAOD',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CANHUMADAC',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAPACUHAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAPOOCAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CARAYMAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CATABUNAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CAYBAGO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'DAGUM',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'DANAO I',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'DANAO II',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'DAWO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'DE VICTORIA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'DINABONGAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'DINAGAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'DINAWACAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'GABAY',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'GADGARAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'GASDO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'GERAGA-AN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'GUIMBAOYAN NORTE',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'GUIMBAOYAN SUR',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'GUIN-ON',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'HAMORAWON',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'HELINO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'HIBABNGAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'HIBATANG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'HIGASAAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'HIMALANDROG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'HUGON ROSALES',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'JACINTO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'JIMAUTAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'JOSE A. RONO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'KALILIHAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'KILIKILI',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'LANGOYON',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'LAPAAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'LIMARAYON',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'LONGSOB',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'LONOY',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MABINI I (CALBAYOG DISTRICT)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MABINI II (OQUENDO DISTRICT)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MACATINGOG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MAG-UBAY',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MAGUINO-O',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MALAGA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MALAJOG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MALAYOG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MALOPALO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MANCOL',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MANTAONG (OQUENDO DISTRICT)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MANUEL BARRAL',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MANUEL BARRAL SR.',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MARCATUBIG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MATOBATO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MAWACAT',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MAYBOG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MAYSALONG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'MIGARA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'NABANG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'NAGA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'NAGUMA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'NAVARRO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'NIJAGA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'OBOOB',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'OBRERO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'OLERA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'OQUENDO (POB.)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PAGBALICAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PALANOGAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PANLAYAHAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PANONONGAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PANOYPOY',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PAYAHAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PENA',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'PINAMOROTAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'RIZAL I (CALBAYOG DISTRICT)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'RIZAL II (OQUENDO DISTRICT)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'ROXAS I (CALBAYOG DISTRICT)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'ROXAS II (OQUENDO DISTRICT)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SALJAG (BAUT)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SAN POLICARPIO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SAN RUFINO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SAPUTAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SIGO',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SINANTAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SINIDMAN OCCIDENTAL',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'SINIDMAN ORIENTAL',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TABAWAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TALAHIBAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TANVAL',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TAPA-E',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TARABUCAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TIGBE',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TINAMBACAN NORTE',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TINAMBACAN SUR',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TINAPLACAN',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TOMALIGUEZ',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'TRINIDAD (SABANG)',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'CALBAYOG',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'ANTOL',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BACYARAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BAROBAYBAY',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BERI',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BINANGGARAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BORONG',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BULAO',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'BULUAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'CAAMLONGAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'CALAYAAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'CALINGONAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'CANBAGTIC',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'CANTICUM',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'DALIGAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'GUINBANGA',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'HINDANG',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'HUBASAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'LITERON',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'LUBANG',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'MACAALAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'MAHANGCAO',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'MALABAL',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'MINATA',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'OTOC',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'PANAYURAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'PASIGAY',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'POLANGI',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'SAN MAURICIO',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'SINALANGTAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'TIMBANGAN',
    },
    {
        CITY: 'CALBIGA',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'ALBALATE',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'BAGONGON',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'BASIAO',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'BULUAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'BUNUANAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'CABUGAWAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'CAGUDALO',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'CAGUSIPAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'CAGUTIAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'CAGUTSAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'CANHAWAN GOTE',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'CANLAPWAS (POB.)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'CINCO',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'DARAHUWAY DACO',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'DARAHUWAY GOTE',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'ESTAKA',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'GUINDAPONAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'GUINSORONGAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'IBOL',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'IGUID',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'LAGUNDI',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'LOBO',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'MANGUEHAY',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'MAULONG',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'MOMBON',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'MUNOZ (POBLACION 14)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'MUÑOZ (POBLACION 14)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'NEW MAHAYAG',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'OLD MAHAYAG',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'PALANYOGON',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'PANGDAN',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'PAYAO',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 1 (BARANGAY 1)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 10 (BARANGAY 10)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 11 (BARANGAY 11)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 12 (BARANGAY 12)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 13 (BARANGAY 13)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 2 (BARANGAY 2)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 3 (BARANGAY 3)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 4 (BARANGAY 4)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 5 (BARANGAY 5)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 6 (BARANGAY 6)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 7 (BARANGAY 7)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 8 (BARANGAY 8)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'POBLACION 9 (BARANGAY 9)',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'PUPUA',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'RAMA',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'SILANGA',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'SOCORRO',
    },
    {
        CITY: 'CATBALOGAN',
        BARANGAY: 'TOTORINGON',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'ADELA HEIGHTS (POB.)',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'ARONG',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'BALOCAWE',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'BANGAHON',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'BESLIG',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'BUAO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'BUNYAGAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'BURABOD I (POB.)',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'BURABOD II (POB.)',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CALIROCAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CANHUMAWID',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CAPARANGASAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CARANAS',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CARMONA',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CASAB-AHAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CASANDIG',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CATORSE DE AGOSTO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CAUGBUSAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'DIAZ',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'DUMALO-ONG (POB.)',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'ELCANO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'GERALI',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'GEREGANAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'GIABOC',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'HAMPTON',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'HETEBAC',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'HIMAMALOTO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'HINAYAGAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'HINUGACAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'HIPARAYAN (KINONONGAN)',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'JASMINEZ',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'LUNGIB',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'MACUGO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'MALAYOG',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'MARCOS',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'MINDA (POB.)',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'NACUBE',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'NALIHUGAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'NATIMONAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'NGOSO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'PALAMBRAG',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'PINAPLATA',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'PIZARRO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'POLOGON',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'PUROG',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAMOYAO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAN ENRIQUE',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAN ISIDRO (DAO)',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAN PELAYO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SENIBARAN (VILLA LEONA)',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'SIDMON',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'TAGNAO',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'TAMBONGAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'TAWIRAN',
    },
    {
        CITY: 'GANDARA',
        BARANGAY: 'TIGBAWON',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'BINOBUCALAN',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'BUCALAN',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'CABALAGNAN',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'CABANG',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'CANANO',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'CONCORD',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'CONSOLABAO',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'DALOSDOSON',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'LIM-AO',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'MALIHAO',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'MUGDO',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'POBLACION 1 (BARANGAY 1)',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'POBLACION 2 (BARANGAY 2)',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'TABAY',
    },
    {
        CITY: 'HINABANGAN',
        BARANGAY: 'YABON',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BARANGAY NO. 1 (POB.)',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BARANGAY NO. 2 (POB.)',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BARANGAY NO. 3 (POB.)',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BARANGAY NO. 4 (POB.)',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BARANGAY NO. 5 (POB.)',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BARANGAY NO. 6 (POB.)',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BARANGAY NO. 7 (POB.)',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BARANGAY NO. 8 (POB.)',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BAWANG',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'CAMAROBO-AN',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'CANDAYAO',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'CANTONGTONG',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'CASAPA',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'CATALINA',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'CRISTINA',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'DOGONGAN',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'GARCIA',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'HINAGA',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'JIA-AN',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'JIDANAO',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'LULUGAYAN',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'MACABETAS',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'MALINO',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'MALOBAGO (VILLALINDA)',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'NAGBAC',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'PARINA',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'TAGBAYAON',
    },
    {
        CITY: 'JIABONG',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'AMAMBUCALE',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'AMANTILLO',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'BINUKYAHAN',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'CALUWAYAN',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'CANYOYO',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'CATATO POB. (DIST. I)',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'FERRERAS',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'LEGASPI',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'LOGERO',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'ODOC',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'PANAN-AWAN',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'PINALANGA',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'PINAMITINAN (POB.)',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'RONO',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'SANTO NINO POB. (DIST. II)',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'TAGALAG',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'TINABANAN',
    },
    {
        CITY: 'MARABUT',
        BARANGAY: 'VELOSO',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'ANGYAP',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'BAG-OTAN',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'BARRUZ (BARANGAY NO. 1)',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'CAMONOAN',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'CAROLINA',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'DEIT',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'INUBOD',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'MABULIGON POB. (BARANGAY NO. 2)',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'MADUROTO POB. (BARANGAY NO. 3)',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'MAHANUD',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'NAGPAPACAO',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'SAN ROQUE (MABUHAY)',
    },
    {
        CITY: 'MATUGUINAO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'ANGYAP',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'BARAYONG',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'BAYOG',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'BERI',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'CALANTAWAN',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'CALAPI',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'CALUYAHAN',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'CANATUAN',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'CANDOMACOL',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'CANVAIS',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'CAPAYSAGAN',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'CARANAS',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'CAULAYANAN',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'HINICA-AN',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'INALAD',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'LINONOBAN',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'MALOBAGO',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'MALONOY',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'MARARANGSI',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'MAYPANGE',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'NEW MINAROG',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'OYANDIC',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'PAMAMASAN',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'POBLACION I-A',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'PUSONGAN',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'SARAO',
    },
    {
        CITY: 'MOTIONG',
        BARANGAY: 'WESTERN SAMAR',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'BUENOS AIRES',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'CALANYUGAN',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'CALOLOMA',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'CAMBAYE',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'CANLAPWAS (POB.)',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'PANGE',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'VIEJO',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'VILLAHERMOSA OCCIDENTAL',
    },
    {
        CITY: 'PAGSANGHAN',
        BARANGAY: 'VILLAHERMOSA ORIENTAL',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'ANAGASI',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'APOLONIA',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'BAGSA',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'BALBAGAN',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'BURAY (BINOGHO)',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'CANTAGUIC',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'CANTAO-AN',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'CANTATO (CANTURAB)',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'CASANDIG I',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'CASANDIG II',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'JOSE RONO',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'LAWAAN I',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'LAWAAN II',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'LOKILOKON',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'MANGCAL',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'MAYLOBE',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'MINAROG',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'NAWI',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'PABANOG',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'PACO',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'PAGSANJAN (PAGSAN-AN)',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'PAGSA-OGAN',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'PEQUIT',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'POBLACION 4',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'POBLACION 5',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'POBLACION 6',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'SULOPAN',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'TABUCAN',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'TAPUL',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'TENANI',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'TIGBAWON',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'TULA',
    },
    {
        CITY: 'PARANAS',
        BARANGAY: 'TUTUBIGAN',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'BANGON',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'BOTOC',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'CALAMPONG',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'CANLOBO',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'CATIGAWAN',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'LALE',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'LAYGAYON',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'LAYO',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'LOCTOB',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'MADALUNOT',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'MAGDAWAT',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'MAMBOG',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'MANAING',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'NABONG',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'OBAYAN',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'PAHUG',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'PARASANON',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'PELAON',
    },
    {
        CITY: 'PINABACDAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'ANQUIANA (ANGKIANA)',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'BAY-ANG',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'BLANCA AURORA',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'BUENAVISTA I',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'BUENAVISTA II',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'BULAO',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'BUNGLIW',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'CAG-OLO-OLO',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'CALUNDAN',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'CANTAGUIC',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'CANYAKI',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'COGTOTO-OG',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'ERENAS',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'GAYONDATO',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'GUINDAPUNAN',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'HERNANDEZ',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'HIMAY',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'JANIPON',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'LINCORO',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'MANCOL (POB.)',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'MATALUD',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'MOBO-OB',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'MOMBON',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'PUHAGAN',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'RANERA',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'RAWIS',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'ROSALIM',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'SAN JORGE I (POB.)',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'SAN JORGE II (POB.)',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'SAPINIT',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'SINIT-AN',
    },
    {
        CITY: 'SAN-JORGE',
        BARANGAY: 'TOMOGBONG',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'AGUINGAYAN',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'BABACLAYON',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'CAN-APONTE',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'CATAYDONGAN',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'GUSA',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'HAGBAY',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'HIBACA-AN',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'HIDUROMA',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'HILUMOT',
    },
    {
        CITY: 'SAN-JOSE-DE-BUAN',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'BONTOD',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'CABAYWA',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'CAMANHAGAY',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'CAMPIYAK',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'CANDUYUCAN',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'HITA-ASAN I',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'HITA-ASAN II',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'INOBONGAN',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'POBLACION BARANGAY 1',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'POBLACION BARANGAY 2',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'POBLACION BARANGAY 3',
    },
    {
        CITY: 'SAN-SEBASTIAN',
        BARANGAY: 'POBLACION BARANGAY 4',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'AGRUPACION',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'ARAPISON',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'AVELINO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'BANA-AO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'BURABOD',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'CAGSUMJI',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'CAMPEIG',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'CAMPERITO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'CAN-IPULAN',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'CANMOROS',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'CAUTOD (POB.)',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'CINCO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'CURRY',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'GAJO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'HINDANG',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'ILO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'INORAGUIAO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'JOLACAO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'LAMBAO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'MATAYONAS',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'MONBON (POB.)',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'NABULO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'NAPURO',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'NAPURO II',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'PALALE',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'PANABATAN',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'PANARUAN',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'SOLSOGON',
    },
    {
        CITY: 'SANTA-MARGARITA',
        BARANGAY: 'SUNDARA',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'BO. INDEPENDENCIA',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'MALAGUINING',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'MALLORGA',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'NAVATAS DAKU',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'NAVATAS GUTI',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'PLACER',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'POBLACION BARANGAY 1',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'POBLACION BARANGAY 2',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'TATABUNAN',
    },
    {
        CITY: 'TALALORA',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'ALCAZAR',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'AWANG',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'BALONGA-AS',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'BANGON GOTE',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'BINALAYAN',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'BISITAHAN',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'CAGTUTULO',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'CAMBATUTAY NUEVO',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'CAMBATUTAY VIEJO',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'CANUNGHAN',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'CATAN-AGAN',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'GALLEGO',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'IMELDA POB. (POSGO)',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'LAHONG',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'LIBUCAN DACU',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'LIBUCAN GOTE',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'LUCERDONI (IRONG-IRONG)',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'MAJACOB',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'MANCARES',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'MARABUT',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'OESTE - A',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'OESTE - B',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'PALENCIA',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'POBLACION A',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'POBLACION B',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'POBLACION C',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'POBLACION D',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'POBLACION E',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'SUGOD',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'TALINGA',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'TIGDARANAO',
    },
    {
        CITY: 'TARANGNAN',
        BARANGAY: 'TIZON',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'BANQUIL',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'BINO-ONGAN',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'CAMBAGUIO',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'CANMUCAT',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'CONANT',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'IGOT',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'INARUMBACAN',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'INASUDLAN',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'LAM-AWAN',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'LAWA-AN',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'MACOPA',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'MALONOY',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'MERCADO (POB.)',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'MIRAMAR (POB.)',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'NAGCADUHA',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'PACAO',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'PACOYOY',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'POLANGI',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'SAN RAFAEL (BUAYA)',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'SOLEDAD (POB.)',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'TAYUD (POB.)',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'TOMABE',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'ULAYAN',
    },
    {
        CITY: 'VILLAREAL',
        BARANGAY: 'VILLAROSA POB. (CAMPIATOT)',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'ASLUM',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'BAGOLIBAS',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'BINANALAN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'BOKINGGAN POB. (ZONE I)',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'BOUGAINVILLA POB. (ZONE II)',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'CABACUNGAN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'CAMAYSE',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'CANSADONG',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'CATICUGAN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'DAMPIGAN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'GUINBALOT-AN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'GUMAMELA POB. (ZONE III)',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'HINANGUDTAN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'IGANG-IGANG',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'LUPIG',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'NEW MANUNCA',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'OLD MANUNCA',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'PAGSULHOGON',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'ROSAL POB. (ZONE IV)',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN EDUARDO',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN PASCUAL (CROSSING)',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SANTA ELENA',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'SANTAN POB. (ZONE V)',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'TAGACAY',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'TOMINAMOS',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'TULAY',
    },
    {
        CITY: 'SANTA-RITA',
        BARANGAY: 'UNION',
    }
];
